import type { FaireProductEntity } from "../../entity_types/product";

export const p_d4dg3ek54t: FaireProductEntity = {
  token: "p_d4dg3ek54t",
  type: "product",
  name: "LM-SW-1012 WCA BUBBLEGUM",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/7abaf9977039b1d44371d7ef29b7b175f9cd564584cc52e97d7e5d0ce08c5148.jpeg",
  galleryImageUrls: [],
  priceDollars: 27.5,
  description: "This women's graphic sweatshirt from Girlie Girl Originals offers a bubblegum-themed design that brings bold, playful style to your wardrobe. Ideal for boutiques seeking distinctive, trend-savvy apparel from a brand known for bold graphics and casual charm.",
  tags: [],
  msrpDollars: 55,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:35.856Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
